import React from 'react';
import { ReelProduct } from '../types';
import './ProductTag.css';

interface ProductTagProps {
  product: ReelProduct;
  isShaking: boolean;
  isExpanding: boolean;
  onClick: () => void;
}

export const ProductTag: React.FC<ProductTagProps> = ({
  product,
  isShaking,
  isExpanding,
  onClick
}) => {
  return (
    <div 
      className={`product-tag ${isShaking ? 'product-tag--shaking' : ''} ${isExpanding ? 'product-tag--expanding' : ''}`}
      onClick={onClick}
    >
      <div className="product-tag__card">
        <img
          src={product.imageUrl}
          alt={product.name}
          className="product-tag__image"
          loading="lazy"
        />
        <div className="product-tag__badge">
          <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor">
            <path d="M9 5l7 7-7 7" stroke="currentColor" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
      </div>
    </div>
  );
};

export default ProductTag;
